// fab.component.ts
import { Component } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ToastController, IonTabs } from '@ionic/angular';
import { Observable } from 'rxjs';

import { ContactsCreatePage } from '../contacts-create/contacts-create.page';
import { InvoiceNewPage } from '../invoice-new/invoice-new.page';
import { AppointmentsNewPage } from '../appointments-new/appointments-new.page';
import { QuoteNewPage } from '../quote-new/quote-new.page';
import { JobNewPage } from '../job-new/job-new.page';

import { NavigationService } from './navigation.service';

@Component({
  selector: 'app-fab',
  templateUrl: './fab.component.html',
  styleUrls: ['./fab.component.scss'],
})
export class FabComponent {

isVisible: Observable<boolean>;

  constructor(
    public modalCtrl: ModalController, 
    public toastController: ToastController,
    private navigationService: NavigationService
  ) {
    this.isVisible = this.navigationService.getIsTopLevelPage();
  }

  // FAB action methods go here
  
  async showNewContactModal() {  
    const modal = await this.modalCtrl.create({  
      component: ContactsCreatePage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const contact = data.data;

        if (contact != null){
          // Toast notification
          //this.presentToast('A new Contact was created.');
        }
        else {
          // User has dismissed creating a new contact without saving
        }
    });

    await modal.present();
  }

  async showNewInvoiceModal() {  
    const modal = await this.modalCtrl.create({  
      component: InvoiceNewPage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const invoice = data.data;

        if (invoice != null){
          // Toast notification
          //this.presentToast('A new Contact was created.');
        }
        else {
          // User has dismissed creating a new contact without saving
        }
    });

    await modal.present();
  }

  async showNewQuoteModal() {  
    const modal = await this.modalCtrl.create({  
      component: QuoteNewPage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const quote = data.data;

        if (quote != null){
          // Toast notification
          //this.presentToast('A new Contact was created.');
        }
        else {
          // User has dismissed creating a new contact without saving
        }
    });

    await modal.present();
  }

  async showNewAppointmentModal() {
    const modal = await this.modalCtrl.create({  
      component: AppointmentsNewPage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const appointment = data.data;

        if (appointment != null){
          // Toast notification
        }
        else {
          // User has dismissed creating a new appointment without saving
        }
    });

    await modal.present();
  }

  async showNewJobModal() {
    const modal = await this.modalCtrl.create({  
      component: JobNewPage  
    });

    modal.onDidDismiss()
      .then((data) => {

        const job = data.data;

        if (job != null){
          // Toast notification
        }
        else {
          // User has dismissed without saving
        }
    });

    await modal.present();
  }
}
